import { Component, Input, OnInit } from '@angular/core';
import { CommentsModalComponent } from '../comments-modal/comments-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { Aspect } from '../../educational-project.type';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
	selector: 'app-comments',
	templateUrl: './comments.component.html',
	styleUrls: ['./comments.component.css'],
})
export class CommentsComponent implements OnInit {
	@Input() aspecto!: Aspect;
	@Input() comments!: any;
	@Input() nameAspect!: string;
	@Input() isEditMode!: boolean;
	@Input() index?: any;
	showDot: boolean = false;

	constructor(public dialog: MatDialog, private ls: LocalStorageService) {}

	ngOnInit() {
		if (this.ls.getItem('role') === 'institution') {
			const aspectComments = this.comments?.[this.nameAspect];
			if (aspectComments) {
				if (this.index !== null && this.index !== undefined) {
					const indexedComments = aspectComments?.[this.index]?.comments;
					if (indexedComments?.length > 0) {
						const lastElement =
							indexedComments[indexedComments.length - 1]?.active;
						if (lastElement) {
							this.showDot = true;
						}
					}
				} else if (aspectComments?.comments?.length > 0) {
					const lastComment = aspectComments.comments;
					const lastElement = lastComment[lastComment.length - 1]?.active;
					if (lastElement) {
						this.showDot = true;
					}
				}
			}
		}
	}
	showHistory() {
		const dialogRef = this.dialog.open(CommentsModalComponent, {
			width: '90%',
			maxWidth: '800px',
			maxHeight: '90vh',
			data: {
				id: this.aspecto.id,
				data: this.aspecto.data,
				aspect: this.nameAspect,
				comment: this.comments,
				index: this.index,
				isEdit: this.isEditMode,
			},
		});

		dialogRef.afterClosed().subscribe((result) => {
			if (result?.confirmed) {
			}
		});
	}
}
